import React, { useState } from "react";
import { Button, Spinner } from "reactstrap";
import { handlePostApis } from "../../service/Api";

const LIMITS = { meta_title: 60, meta_description: 160 };

const Counter = ({ value, limit }) => {
  const length = value?.length ?? 0;
  return (
    <span className={`hc-counter ${length > limit ? "is-over" : ""}`}>
      {length}/{limit} characters recommended
    </span>
  );
};

const SeoTab = ({ seo, onSaved }) => {
  const [draft, setDraft] = useState(seo);
  const [saving, setSaving] = useState(false);
  const set = (key, value) => setDraft((d) => ({ ...d, [key]: value }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    const res = await handlePostApis("admin/homepage/seo", draft);
    setSaving(false);
    alert(res?.data?.message || "Something went wrong");
    if (res?.data?.success) onSaved();
  };

  return (
    <form className="hc-card is-open" onSubmit={save}>
      <div className="hc-card-head">
        <span className="hc-title">Homepage SEO</span>
      </div>
      <div className="hc-card-body">
        <div className="hc-field">
          <label className="hc-label">Meta title</label>
          <input className="form-control" required value={draft.meta_title} onChange={(e) => set("meta_title", e.target.value)} />
          <Counter value={draft.meta_title} limit={LIMITS.meta_title} />
        </div>
        <div className="hc-field">
          <label className="hc-label">Meta description</label>
          <textarea
            className="form-control"
            rows={3}
            required
            value={draft.meta_description}
            onChange={(e) => set("meta_description", e.target.value)}
          />
          <Counter value={draft.meta_description} limit={LIMITS.meta_description} />
        </div>
        <div className="hc-field">
          <label className="hc-label">Keywords (comma separated)</label>
          <input className="form-control" value={draft.keywords} onChange={(e) => set("keywords", e.target.value)} />
        </div>
        <div className="hc-field">
          <label className="hc-label">Social share image URL (1200×630)</label>
          <input className="form-control" value={draft.og_image} onChange={(e) => set("og_image", e.target.value)} />
        </div>
        <div className="hc-footer">
          <Button color="primary" type="submit" disabled={saving}>
            {saving ? <Spinner size="sm" /> : "Save SEO"}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default SeoTab;
